import views from './Views'
import macros from './Macros'
import actions from './Actions'
import relations from './Relations'
import types from './Types'
import attributes from './Attributes'

accumulated = {
  actions...,
  attributes...,
  relations...,
  types...,
  views...,
  macros...
}

# props: {
#   setCurrentItem
#   setOpenInConsole
#   setTabDisabled
#   setTableConfig
#   params
#   history
#}

export default onSelect = (node, props) ->
  accumulated[node.type]?(node, props)
